const PACKAGE_FALLBACK = {
  id: "general-collab",
  title: "General Collaboration",
  platform: "",
  niche: "",
  currencySymbol: "INR ",
  price: null,
};

const normalizePlatformName = (value) => {
  const clean = String(value || "").trim().toLowerCase();
  if (clean === "instagram") return "Instagram";
  if (clean === "youtube") return "YouTube";
  return clean ? clean[0].toUpperCase() + clean.slice(1) : "";
};

const formatCompactNumber = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";
  return new Intl.NumberFormat("en-IN", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(num);
};

const formatCurrency = (value, symbol = "INR ") => {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return "Not specified";
  return `${symbol}${new Intl.NumberFormat("en-IN").format(num)}`;
};

const getCampaignBudgetLabel = (campaign) => {
  const commission = campaign?.commission || {};
  const amount =
    commission.amount ??
    commission.cpe ??
    commission.cpm ??
    commission.percentage ??
    null;
  const symbol = commission?.currency?.symbol || "INR ";
  if (amount == null) return "Budget not specified";
  return formatCurrency(amount, symbol);
};

const normalizeInfluencerPackages = (packages) => {
  if (!packages) return [PACKAGE_FALLBACK];

  const normalized = [];
  const pushPackage = (item, index, platformHint = "") => {
    const title = String(item?.title || "").trim();
    const price = Number(item?.price);
    const currencySymbol = item?.currencySymbol || item?.currency || "INR ";
    const platform = normalizePlatformName(item?.platform || platformHint);
    const niche = String(item?.niche || item?.category || "").trim();
    normalized.push({
      id: item?.id || `${platformHint || "package"}-${index}`,
      title: title || `${platformHint ? `${platformHint} ` : ""}Package`,
      price: Number.isFinite(price) ? price : null,
      currencySymbol,
      platform,
      niche,
    });
  };

  if (Array.isArray(packages)) {
    packages.forEach((item, index) => pushPackage(item, index, item?.platform || ""));
  } else {
    const instagram = packages.Instagram || packages.instagram || [];
    const youtube = packages.YouTube || packages.youtube || [];
    instagram.forEach((item, index) => pushPackage(item, index, "Instagram"));
    youtube.forEach((item, index) => pushPackage(item, index, "YouTube"));
  }

  return normalized.length > 0 ? normalized : [PACKAGE_FALLBACK];
};

export {
  PACKAGE_FALLBACK,
  formatCompactNumber,
  formatCurrency,
  getCampaignBudgetLabel,
  normalizeInfluencerPackages,
};
